<div class="flex justify-center items-center">
  <clr-checkbox-container>
    <clr-checkbox-wrapper>
      <input
        type="checkbox"
        clrCheckbox
        [disabled]="disabled"
        [indeterminate]="disabled"
        [checked]="selected"
        (change)="selectedChange.emit(!selected)"
      />
    </clr-checkbox-wrapper>
  </clr-checkbox-container>
</div>
<!-- <div
    class="toggle-label"
    [class.selected]="selected"
    [class.disabled]="disabled"
    *ngIf="label"
    (click)="selectedChange.emit(!selected)"
>
    {{ label }}
</div> -->
